import Error404Page from "client/common/components/errors/Error404Page";
import { urls } from "client/routes";

const NotFound = () => {
  return (
    <Error404Page
      title="Product Not Found!"
      description="We could not find that product in our catalog."
      buttonText="Find a Product"
      buttonLink={urls.products.search.to()}
    />
  );
};

export default NotFound;
